export const timezones = [
    'Asia/Manila', 
    'America/Toronto', 
    'US/Pacific'
];
